import { requestManager } from '../../requestManager';

import { API_PATH } from '../../config/config';

class SelectBusiness {
  /**
   * 市町村コードから申請項目を取得
   * @param {String} lgCd 市町村コード
   * @return {Promise<Object>} 条件に合致する申請項目
   */
  getRecItems = async (lgCd) => {
    const response = await requestManager.post(`${API_PATH}/selectbusiness/r`, {
      lgCd,
    });

    return response.data;
  };
}

export default new SelectBusiness();
